// Adaptador de MENSAJES AUTOMÁTICOS por evento sobre lealify-base (/messages/*),
// reemplazo de la config en Firestore (businesses/{id}.<evento>Message). Los disparos
// viven en los eventos de lealtad de base (check-in/canje/feedback/referido); aquí solo
// se administra la config. Variables estilo @nombre (las resuelve el render de base).
import { baseApi } from './baseClient';

export interface EventEmailSettings {
  enabled: boolean;
  subject: string;
  template: string;
}

export interface EventSettings {
  enabled: boolean;
  template: string;
  alert_phone?: string | null;   // solo feedback_alert
  threshold?: number;            // solo low_balance
  image_url?: string | null;     // compat: 1 imagen (welcome/visit/feedback/referral/low_balance)
  images?: string[];             // hasta 3 imágenes, rotación aleatoria (todos los eventos)
  email?: EventEmailSettings;    // canal de CORREO independiente del de WhatsApp (hoy: welcome)
}

export interface MessagesSettings {
  welcome: EventSettings;
  visit: EventSettings;
  feedback_alert: EventSettings;
  low_balance: EventSettings;
  referral: EventSettings;
  // Membresías F4 (20-oct-2026): avisos del cron (correo por defecto). Canal excluyente como welcome.
  membership_expiring: EventSettings;
  membership_expired: EventSettings;
}

export type EventKey = keyof MessagesSettings;

export interface WhatsAppStatus {
  configured: boolean;
  status?: string;
  me?: any;
  connected: boolean;   // configured && status === 'WORKING'
}

export const messagesApi = {
  getSettings: () =>
    baseApi.get<{ settings: MessagesSettings }>('/messages/settings').then((r) => r.settings),

  // Patch de un solo evento. Devuelve la config completa ya fusionada.
  updateEvent: (key: EventKey, patch: Partial<EventSettings>) =>
    baseApi.put<{ settings: MessagesSettings }>('/messages/settings', { [key]: patch }).then((r) => r.settings),

  whatsappStatus: () => baseApi.get<WhatsAppStatus>('/messages/whatsapp-status'),

  // Correo de bienvenida renderizado con la marca real del tenant (iframe del editor).
  // POST a propósito: el texto del usuario jamás viaja en query string (regla WAF).
  emailPreview: (subject: string, body: string) =>
    baseApi.post<{ html: string; subject: string; from: string }>('/messages/email-preview', { subject, body }),

  // Cuántos clientes activos tienen correo capturado (aviso de cobertura del editor).
  emailCoverage: () => baseApi.get<{ total: number; with_email: number }>('/messages/email-coverage'),
};

export default messagesApi;
